import { Ability, detectSubjectType } from '@casl/ability'
export default new Ability([{ action: 'read', subject: 'teacher' }], { detectSubjectType: subject => subject && subject.subject ? subject.subject : detectSubjectType(subject) })
